import { render, staticRenderFns } from "./home-model.vue?vue&type=template&id=79bbde07&scoped=true&"
import script from "./home-model.vue?vue&type=script&lang=js&"
export * from "./home-model.vue?vue&type=script&lang=js&"
import style0 from "./home-model.vue?vue&type=style&index=0&id=79bbde07&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bbde07",
  null
  
)

export default component.exports